import React, { useEffect, useState } from 'react'
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput'
import styles from "./styles.module.scss";
import { regex } from 'views/pages/manage/common/constant/regex/index';
import { CheckBox } from 'views/pages/manage/unAssigned/collectPayment/selectCharges/components/Checkbox';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { columnsList } from './constants';
import { inputStyle } from '../sapPurchaseGrn/constant';
const ListEditableRows = ({ rows, rowFormHandler, serviceEntryType }) => {

  return rows?.map((item, index) => (
    <>
      <div className={`${styles["table-list"]} mt-3 mx-3`} key={`${item?.id || index}`}>
        {columnsList.map((col) => {
          switch (col?.type) {
            case "input":
              return <AInput
                key={`${index}-${col?.colKey}`}
                type="text"
                value={item[col?.colKey] || ""}
                handler={(val) => {
                  const isNumericField = ["quantity", "price"].includes(col.colKey);
                  const newValue = isNumericField ? parseFloat(val) || 0 : val;
                  rowFormHandler(index, col.colKey, newValue);

                  if (["quantity", "price"].includes(col.colKey)) {
                    const quantity = col.colKey === "quantity" ? newValue : parseFloat(item.quantity) || 0;
                    const price = col.colKey === "price" ? newValue : parseFloat(item.price) || 0;
                    const netValue = +((quantity * price).toFixed(2));
                    rowFormHandler(index, "netValue", netValue);
                  }
                }}
                disabled={col.disabled || (serviceEntryType != 'createSE')}
                placeholder="Enter"
                style={inputStyle}
              // regex={col?.colKey === 'quantity' || col?.colKey === 'price' ? regex?.numericDecimal : regex?.alphaNumericWithSpaceAndUnderscore}
              />
            case "checkbox":
              if (serviceEntryType !== "createSE") return null;
              return (
                <CheckBox
                  key={`${index}-${col?.colKey}`}
                  handler={(checked) => rowFormHandler(index, col?.colKey, checked)}
                  isChecked={item[col?.colKey] || false}
                  disabled={col?.disabled}
                />
              );
            default:
              return (item.serviceList?.length > 0 || true) ? (
                <AButton
                  key={`${index}-${col?.colKey}`}
                  variant="link"
                  className="no-ml-btn"
                  onClick={() => {
                  }}
                  size="xs"
                >
                  View
                </AButton>
              ) : null;
          }

        })}

      </div>
    </>

  ))
}

export default ListEditableRows;